/**
 * MetroM — square rosso con "M" bianca al centro, stile stazioni metropolitane
 * italiane (Roma / Milano). Renderizzato come icona SVG compatibile con l'API
 * dei componenti Lucide (`className`, `style`, `strokeWidth`, `size`).
 *
 * NOTE: A differenza delle icone Lucide, questo componente ignora `color` da
 * `style` sul path (usiamo colori fissi rosso/bianco per riconoscibilità).
 */

const MetroM = ({ className = "", style, size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    style={style}
    aria-hidden="true"
    {...props}
  >
    {/* Red rounded square background */}
    <rect x="2" y="2" width="20" height="20" rx="4" fill="#DC2626" />
    {/* White capital M — heavy weight, geometric */}
    <path
      d="M6.2 17.5V6.5h2.5l3.3 7.2 3.3-7.2h2.5v11h-2.2v-6.9L12.8 17.3h-1.6L8.4 10.6v6.9H6.2z"
      fill="#FFFFFF"
    />
  </svg>
);

export default MetroM;
